import { Form, Input } from '@mairistem/composants';
import { type Rib, TiersRibSearchInput } from '@mairistem/comptabilite';
import type React from 'react';
import './ReferencesBancaire.css';

interface ReferencesBancaireProps {
	identifiantRib: number | string;
	libelleVirementZoneLibre: string;
	libelleVirementZonLibre: string;
	onChange: (
		e: React.ChangeEvent<HTMLInputElement>,
		{
			name,
			value,
		}: {
			name: string;
			value: string;
		},
	) => void;
	onRibChange: (rib: Rib) => void;
	ribs: Rib[];
}

const ReferencesBancaire = ({
	identifiantRib,
	libelleVirementZoneLibre,
	libelleVirementZonLibre,
	onChange,
	onRibChange,
	ribs,
}: ReferencesBancaireProps) => (
	<>
		<TiersRibSearchInput
			identifiantRib={Number(identifiantRib)}
			// @ts-expect-error name
			name="iban"
			onChange={onRibChange}
			ribs={ribs}
		/>
		<Form.Group widths="equal">
			<Form.Field
				control={Input}
				data-testid="libelleVirement"
				label="Libellés de virement"
				maxLength={140}
				name="libelleVirementZoneLibre"
				onChange={onChange}
				placeholder="Informations principales destinées au bénéficiaire sur son relevé de compte"
				value={libelleVirementZoneLibre ?? ''}
			/>
			<Form.Field
				control={Input}
				data-testid="complementLibelleVirement"
				label="‎"
				maxLength={140}
				name="libelleVirementZonLibre"
				onChange={onChange}
				placeholder="Informations complémentaires destinées au bénéficiare sur son relevé de compte"
				value={libelleVirementZonLibre ?? ''}
			/>
		</Form.Group>
	</>
);

export default ReferencesBancaire;
